import Axios from 'axios'
import { Notification } from 'element-ui'
import { Cookies } from 'quasar'
// 定义url字符串拼接的方法
const setUrlQuery = (url, query) => {
    if (!url) return ''
    if (query) {
        let queryArr = []
        for (const key in query) {
            if (query.hasOwnProperty(key)) {
                queryArr.push(`${key}=${query[key]}`)
            }
        }
        if (url.indexOf('?') !== -1) {
            url = `${url}&${queryArr.join('&')}`
        } else {
            url = `${url}?${queryArr.join('&')}`
        }
    }
    return url
}

export default {
    data: {},
    download: function (key) {
        const { el, binding, node } = this.data[key]
        const path = el.getAttribute('url')
        const label = el.getAttribute('label')
        const hint = el.getAttribute('hint')
        let flag = true
        let params = {}
        if (binding.arg != 'def') {
            if (binding.arg == 'post') {
                params = JSON.parse(
                    JSON.stringify({
                        ...node.context[binding.expression],
                    })
                )
            } else {
                params = JSON.parse(
                    JSON.stringify({
                        [binding.arg]: node.context[binding.expression],
                    })
                )
            }
            Object.keys(params).forEach(item => {
                if (typeof params[item] == 'object') {
                    if (params[item].length == 0) {
                        flag = false
                    }
                } else {
                    if (!params[item]) {
                        flag = false
                    }
                }
            })
        } else {
            params = JSON.parse(
                JSON.stringify({
                    ...node.context[binding.expression],
                })
            )
        }

        if (!flag)
            return Notification.warning({
                title: hint || '请选择数据',
            })
        if (!binding.arg) {
            params = JSON.parse(
                JSON.stringify({
                    ...node.context[binding.expression],
                })
            )
        }
        Axios({
            url: '/api' + path,
            method: binding.arg == 'post' ? 'post' : 'get',
            //   responseType: "arrayBuffer",
            responseType: 'blob',
            data: params,
            params: binding.arg == 'post' ? null : params,
            headers: {
                Authorization: Cookies.get('PC_TOKEN'),
            },
        }).then(res => {
            if (res.headers['content-type'].indexOf('json') != -1) {
                const reader = new FileReader() //创建一个FileReader实例
                reader.readAsText(res.data, 'utf-8') //读取文件,结果用字符串形式表示
                reader.onload = function () {
                    //读取完成后,**获取reader.result**
                    const data = JSON.parse(reader.result)
                    Notification.success({
                        title: '操作成功',
                        message: data.data || '报表生成中，请至“账号中心-下载管理”下载',
                    })
                }
                return
            }
            let text = ''
            if (res.headers['content-disposition']) {
                text = res.headers['content-disposition'].split('=')[1]
                text = decodeURIComponent(text)
            }

            //   let blob = new Blob([res], {
            //     type:
            //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            //   });
            //   console.log(blob);
            const url = window.URL.createObjectURL(res.data)
            console.log(url)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.setAttribute('download', `${text ? text : label ? label + '.xlsx' : '导出文件.xlsx'}`)
            a.href = url
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            Notification.success({ title: '下载成功' })
        })
    },
}
